import React, { useState } from 'react';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('admin@tashop.online');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (password) onLogin();
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>TA SHOP Admin</h1>
        <form onSubmit={handleLogin}>
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
}
